import { useTheme } from "@emotion/react";
import { Close, Save } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { formatArray } from "utility";
import React from "react";
import { useSelector } from "react-redux";
import { closeModal } from "store/reducers/tools";
import { CustomText } from "components";

export const CommonModal = () => {
  const modalData = useSelector((state) => state?.common?.modal ?? []);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <div>
      {formatArray(modalData).map((item, itemIndex) => {
        const handleClose = () => {
          if (typeof item?.onClose === "function") item.onClose();
          closeModal();
        };

        const handleSave = () => {
          if (typeof item?.onSave === "function") item.onSave();
        };

        return (
          <Dialog
            key={itemIndex}
            open={Boolean(item?.isOpen)}
            // onBackdropClick={handleClose}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={item.size ?? "sm"}
            fullScreen={fullScreen}
            // disableBackdropClick
            scroll="paper"
          >
            {!item?.noFrame && (
              <DialogTitle className="flex justify-between items-center bg-back">
                {item?.title ?? ""}
                <IconButton onClick={handleClose} size="small">
                  <Close />
                </IconButton>
              </DialogTitle>
            )}
            <DialogContent
              dividers={!item?.noFrame}
              className="w-full scroll-thumb"
            >
              <div className="scroll-scroll-thumb-x">
                <div>{item?.content ?? ""}</div>
              </div>
            </DialogContent>
            {(!item.noFrame || item.footer) && (
              <DialogActions>
                <Grid
                  container
                  spacing={2}
                  justifyContent={item?.noFrame ? "center" : "flex-end"}
                >
                  {Boolean(item?.footer) && (
                    <Grid item>{item?.footer ?? ""}</Grid>
                  )}
                  <Grid item>
                    {item?.noFrame ? (
                      <></>
                    ) : (
                      <Grid container spacing={1}>
                        {typeof item?.onSave === "function" ? (
                          <Grid item>
                            <Button
                              onClick={handleSave}
                              variant="contained"
                              color="primary"
                              startIcon={<Save />}
                            >
                              Save
                            </Button>
                          </Grid>
                        ) : null}
                        <Grid item>
                          <Button
                            onClick={handleClose}
                            variant="outlined"
                            color="primary"
                          >
                            <CustomText
                              variant="body2"
                              bold={600}
                              color="secondary"
                            >
                              Close
                            </CustomText>
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </DialogActions>
            )}
          </Dialog>
        );
      })}
    </div>
  );
};
